import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import amplitude from 'amplitude-js';
import { togglePopup } from 'apps/auth/actions/appAction';
import { DangerouslyHtml } from 'apps/auth/components/common/DangerouslyHtml/DangerouslyHtml';
import PopupButton from 'apps/auth/components/common/Popup/PopupButton';
import SimplePopup from 'apps/auth/components/common/Popup/SimplePopup';
import { PAYSEND_PLUS } from 'apps/auth/components/paysendPlus/utils';
import { PLUS_BENEFIT_PROMO_SHOWN } from 'apps/auth/constants/amplitude/AmplitudeEvents';

const FeeTextPopup = ({ popupRef = null, ...props }) => {
    useEffect(() => {
        if (props.subscriptionType && props.subscriptionType === PAYSEND_PLUS) {
            amplitude.getInstance().logEvent(PLUS_BENEFIT_PROMO_SHOWN);
        }
    }, []);

    const onClickHandler = (e) => {
        e.preventDefault();
        if (props.closeHandler) {
            props.closeHandler(e);
        } else if (popupRef?.current) {
            popupRef.current?.close();
        } else {
            props.togglePopup(false);
        }
    };

    const gotItButton = props.gotItButton || props.gotIt || props.feeLandingCloseTitle;

    const getText = (text) => {
        return <DangerouslyHtml dangerouslyHtml={text} />;
    };

    return (
        <SimplePopup text={getText(props.text)} popupRef={popupRef} handleClose={props.closeHandler} onPopupClose={props.onPopupClose}>
            {/*{props.isComment && props.isShowTerms && getLinkForComment()}*/}
            <PopupButton title="Got it" iconName="check" text={gotItButton} onClick={onClickHandler} />
        </SimplePopup>
    );
};
const mapStateToProps = (state) => {
    return {
        lang: state.language.lang,
        country: state.app.country,
        feeLandingKoreaInfo: state.messages.pageMessages.feeLandingKoreaInfo,
        feeLandingPakistanInfo: state.messages.pageMessages.feeLandingPakistanInfo,
        feeLandingIndiaUPIInfo: state.messages.pageMessages.feeLandingIndiaUPIInfo,
        feeLandingChinaAlipayInfo: state.messages.pageMessages.feeLandingChinaAlipayInfo,
        feeLandingChinaWeixinInfo: state.messages.pageMessages.feeLandingChinaWeixinInfo,
        feeLandingCanadaInteracInfo: state.messages.pageMessages.feeLandingCanadaInteracInfo,
        feeLandingCanadaPeopleTrustInteracInfo: state.messages.pageMessages.feeLandingCanadaPeopleTrustInteracInfo,
        feeLandingTermsAndCond: state.messages.pageMessages.feeLandingTermsAndCond,
        feeLandingCloseTitle: state.messages.pageMessages.feeLandingCloseTitle,
        gotItButton: state.messages.pageMessages.gotItButton,
        gotIt: state.messages.pageMessages.gotIt,
        cashPickupGuide: state.messages.pageMessages.cashPickupGuide,
        cashHomeGuide: state.messages.pageMessages.cashHomeGuide,
        cashPickupVietcomBankGuide: state.messages.pageMessages.cashPickupVietcomBankGuide,
        cashPickupOtherVietnamBankGuide: state.messages.pageMessages.cashPickupOtherVietnamBankGuide,
        cashPickupIssegBankGuide: state.messages.pageMessages.cashPickupIssegBankGuide,
        cashPickupChedrauiGuide: state.messages.pageMessages.cashPickupChedrauiGuide,
        feeLandingSARInfo: state.messages.pageMessages.feeLandingSARInfo,
        feeChinaBankAccountInfo: state.messages.pageMessages.feeChinaBankAccountInfo,
    };
};
FeeTextPopup.propTypes = {
    popupRef: PropTypes.shape({ current: PropTypes.object }),
    closeHandler: PropTypes.func,
};

export default connect(mapStateToProps, { togglePopup })(FeeTextPopup);
